/* eslint-disable no-console */
// utils/calculateVentas.js
export const getConvertedImporte = (oportunidad, rate) =>
  oportunidad.moneda_dolar ? (oportunidad.importe || 0) * rate : oportunidad.importe || 0;

export const getConvertedImporteBTL = (oportunidadBTL, rate) =>
  oportunidadBTL.moneda_dolar ? (oportunidadBTL.total_investment || 0) * rate : oportunidadBTL.total_investment || 0;

export const normalizeMonth = (month, createdAt, ano = null) => {
  if (!month || typeof month !== "string") {
    if (ano) return `01-${ano}`;
    return null;
  }
  if (/^\d{2}-\d{4}$/.test(month)) return month;
  const monthNum = parseInt(month, 10);
  if (!isNaN(monthNum) && monthNum >= 1 && monthNum <= 12 && ano) {
    return `${monthNum.toString().padStart(2, "0")}-${ano}`;
  }
  return null;
};

export const calculateSalesSums = (
  oportunidades,
  oportunidadesBTL,
  year,
  startMonth = 1,
  endMonth = 12,
  rate,
  pais
) => {
  const filterAndSum = (ops, status, field, includeMin = false, isBTL = false) => {
    const filteredOps = ops.filter((op) => {
      if (!op[field]) return false;
      let effectiveMonth, effectiveYear;

      if (field === "mes_factura" && op.facturafecha) {
        const facturaDate = new Date(op.facturafecha);
        if (!isNaN(facturaDate)) {
          effectiveMonth = facturaDate.getMonth() + 1;
          effectiveYear = facturaDate.getFullYear();
        }
      }

      const [month, ano] = effectiveMonth
        ? [effectiveMonth, effectiveYear]
        : op[field]?.split("-").map(Number) || [null, null];
      const estatus = isBTL ? (op.status === 100 ? "100%" : `${op.status || 0}%`) : op.estatus;
      return (
        estatus === status &&
        !op.eliminada &&
        ano === parseInt(year) &&
        month >= startMonth &&
        month <= endMonth &&
        op.pais === pais
      );
    });

    const groups = {};
    filteredOps.forEach((op) => {
      const key = op.client_id;
      if (!groups[key]) groups[key] = [];
      const importe = isBTL ? getConvertedImporteBTL(op, rate) : getConvertedImporte(op, rate);
      groups[key].push(importe);
    });

    let total = 0;
    for (const key in groups) {
      const importes = groups[key];
      total += includeMin && importes.length > 1 ? Math.min(...importes) : importes.reduce((sum, val) => sum + val, 0);
    }

    return total;
  };

  const sumCierresRegular = filterAndSum(oportunidades, "100%", "mes_cierre", false, false);
  const sumCierresBTL = filterAndSum(oportunidadesBTL, "100%", "mes_cierre", false, true);
  const sumaImportes100Regular = filterAndSum(oportunidades, "100%", "mes_factura", false, false);
  const sumaImportes100BTL = filterAndSum(oportunidadesBTL, "100%", "mes_factura", false, true);
  const sumaImportes90 = filterAndSum(oportunidades, "90%", "mes_cierre", true, false);
  const sumaImportes75 = filterAndSum(oportunidades, "75%", "mes_cierre", true, false);
  const sumaImportes50 = filterAndSum(oportunidades, "50%", "mes_cierre", true, false);
  const sumaImportes0 = filterAndSum(oportunidades, "0%", "mes_cierre", true, false);

  return {
    sumCierres: sumCierresRegular + sumCierresBTL,
    sumaImportes100: sumaImportes100Regular + sumaImportes100BTL,
    sumaImportes90,
    sumaImportes75,
    sumaImportes50,
    sumaImportes0,
  };
};

export const calculateForecast = (sum90, sum75) => sum90 * 0.75 + sum75 * 0.5;
